import appGlobalScript from 'C:/Arbeit/studio38/kubinaut_2024_2/project/kubinaut/kubinaut/site_static/site/npm/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = appGlobalScript;
